// Note this should use a class to disable the button will need a FE to add 
// Note : this should be tied into the ares alidation at some point
// When callback has finished disable the submit buttons in forms that have a captcha
function onloadRecaptchaCallback(){
    var recap = document.getElementsByClassName('g-recaptcha');
    var i;
    for (i = 0; i < recap.length; i++) {
        // disable each button
        var formBtn = recap[i].closest('form').querySelector('button[type="submit"]');
        // We can change these rules to drop in a class 
        formBtn.disabled = true;
        formBtn.style.opacity = '0.5';
    }
}
// If the captcha has expired re-disable form buttons
function recaptchaExpired(){
    onloadRecaptchaCallback();
}
// After the user/bot completes the captcha
function recaptchaCallback() {
    // send promise
    return new Promise(function(resolve, reject) {  
        // if undefined let recaptcha know we rejected it
        if (grecaptcha === undefined) {
            reject();
        }
        // grab the response 
        var response = grecaptcha.getResponse();
        // If no response let recaptcha know we rejected it as we cant go furthur
        if (!response) {
            reject();
        }
        // Make the call to verify w/google that we are dealing with a human and not a smar bot
        fetch(`${window.location.origin}/wp-content/themes/asbestos/ajax/recaptcha.php`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: `response=${encodeURIComponent(response)}`
        })
        .then(response => {
            if (response.ok) {
                return response.text();
            } else {
                console.warn('recaptcha errors found. Please contact webmaster');
                throw new Error('Request failed');
            }
        })
        .then(data => {
            if (data === '1') {
                resolve();
                const recap = document.getElementsByClassName('g-recaptcha');
                const formBtn = recap[0].closest('form').querySelector('button[type="submit"]');
                formBtn.disabled = false;
                formBtn.style.opacity = '1.0';
                return false;
            } else {
                reject();
            }
        })
        .catch(error => {
            console.error(error);
            reject();
        });
    }); //end promise
}